module.exports = __webpack_public_path__ + "static/media/deilunch.e273b8e9.png";